import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Home } from "lucide-react";
import { api, formatError } from "@/lib/api";

export const HOUSING_LABELS = {
  available: { label: "Beds available", dot: "bg-emerald-500" },
  limited: { label: "Limited beds", dot: "bg-amber" },
  full: { label: "Currently full", dot: "bg-red-600" },
};

export const useHousing = () => {
  const [h, setH] = useState(null);
  useEffect(() => {
    api.get("/housing").then((r) => setH(r.data || null)).catch(() => setH(null));
  }, []);
  return [h, setH];
};

export const HousingAdmin = () => {
  const [h, setH] = useHousing();
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setNote(h?.note || ""); }, [h?.note]);

  const save = async (status) => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/housing", { status, note });
      setH(data);
      toast.success(`Housing marked: ${HOUSING_LABELS[status].label}`);
    } catch (e) { toast.error(formatError(e)); } finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-housing-card" className="mt-6 flex flex-col gap-5 rounded-2xl bg-gum p-6 text-sand lg:flex-row lg:items-center">
      <div className="flex items-center gap-4 lg:w-72">
        <Home className="h-8 w-8 shrink-0" strokeWidth={1.5} />
        <div>
          <p className="eyebrow text-amber">Safe housing</p>
          <p data-testid="admin-housing-current" className="mt-1 font-display text-2xl">{h ? HOUSING_LABELS[h.status]?.label : "…"}</p>
        </div>
      </div>
      <input data-testid="admin-housing-note" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Public note (optional), e.g. 'Call to check family rooms'"
        className="flex-1 rounded-xl border border-sand/25 bg-transparent p-3 text-sm text-sand placeholder:text-sand/60 focus:border-amber focus:outline-none" />
      <div className="flex flex-wrap gap-2">
        {Object.entries(HOUSING_LABELS).map(([k, v]) => (
          <button key={k} disabled={busy} data-testid={`admin-housing-${k}`} onClick={() => save(k)}
            className={`flex items-center gap-2 rounded-full border px-4 py-2 text-sm transition-colors disabled:opacity-60 ${h?.status === k ? "border-sand bg-sand text-ink" : "border-sand/30 hover:border-sand"}`}>
            <span className={`h-2.5 w-2.5 rounded-full ${v.dot}`} />{v.label}
          </button>
        ))}
      </div>
    </div>
  );
};
